import seapointLogo from '../../assets/images/logo-seapoint-name.svg';

export const SeapointLogo = () => {
  return <img src={seapointLogo} alt="Seapoint" loading="eager" fetchpriority="high" className="h-8 w-max" />;
};
